import { Icon } from "@circleco/compass/components/Icon";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";
import type { FileUploadState } from "@/react/hooks/useParallelDirectUploads";

import { CircularProgress } from "../../Shared/CircularProgress";

interface LoadingThumbnailProps {
  fileStates: FileUploadState[];
  index: number;
}

export const LoadingThumbnail = ({
  fileStates,
  index,
}: LoadingThumbnailProps) => {
  const fileState = fileStates[index];

  if (!fileState) {
    return null;
  }

  return (
    <div className="shrink-0 p-1">
      <div className="bg-tertiary flex size-12 items-center justify-center rounded-md">
        {fileState.status === "completed" && (
          <Icon name="circle-check-filled" size="sm" />
        )}
        {fileState.status === "uploading" && (
          <CircularProgress
            percentage={fileState.progress}
            size={18}
            strokeWidth={1.5}
          />
        )}
        {fileState.status === "error" && (
          <Typography variant="label-xs" color="primary">
            {t("image_space.post_modal.steps.adjust_images.file_error")}
          </Typography>
        )}
      </div>
    </div>
  );
};
